import { create } from "zustand";

// CLIF refers to pages that user can select item(s) from list:
// - Career levels
// - Industries
// - Functions
// - Travel willingness
// - Location preferences
// - Current/desired salary ranges
// We store form data in state management before navigating to CLIF pages and restore it once user back to form page

/**
 * indicate mode of selection
 * - "single": any selection replaced with previous one
 * - "multiple": selection work as toggle action and user can select multiple items
 * @default "single"
 */
export type ModeType = "single" | "multiple";
type ClifStateType = Record<string, unknown>;

interface ClifState {
  clifState: ClifStateType;
  setClifState: (state: ClifStateType) => void;
  updateClifState: (updates: Partial<ClifStateType>) => void;
  clearClifState: () => void;
}

const initialClifState: ClifStateType = {};

export const useClifStore = create<ClifState>((set) => ({
  clifState: initialClifState,
  setClifState: (state: ClifStateType) => set({ clifState: state }),
  updateClifState: (updates: Partial<ClifStateType>) =>
    set((state) => ({ clifState: { ...state.clifState, ...updates } })),
  clearClifState: () => set({ clifState: initialClifState }),
}));
